


















import { PaginationData } from '@/types';
import Vue, { PropType } from 'vue';

const DEFAULT_PER_PAGE = 20;

export default Vue.extend({
  name: 'FiltersPanel',

  props: {
    paginationData: {
      type: Object as PropType<PaginationData>,
      required: true,
    },
  },

  watch: {
    parPageData(newValue) {
      this.perPage = newValue;
    },
  },

  methods: {
    changePerPage(event) {
      this.$emit('changePerPage', event.target.value);
    },
  },

  data() {
    return {
      perPage: this.paginationData?.perPage || DEFAULT_PER_PAGE,
    };
  },
});
